import { mutationTypes } from '@/core/constants'
import { FiltroUtils } from '@/core/utils'

export default {
	[mutationTypes.ATA.SET_FILTRO_LISTAGEM](state, filtro) {
		state.filtro = filtro
	},

	[mutationTypes.ATA.SET_PAGINACAO_LISTAGEM](state, paginacao) {
		state.paginacao = paginacao
	},

	[mutationTypes.ATA.RESETAR_PAGINA_LISTAGEM](state) {
		state.paginacao.page = 1
	},

	[mutationTypes.ATA.LIMPAR_FILTRO_LISTAGEM](state) {
		FiltroUtils.limparFiltroAvancado(state.filtro)
	},

	[mutationTypes.ATA.SET_INFORMACOES_ATA](state, informacoesAta) {
		state.informacoesAta = informacoesAta
	},

	[mutationTypes.ATA.SET_NUMERO_ATA](state, numero) {
		state.informacoesAta.numero = numero
	},

	[mutationTypes.ATA.RESET_INFORMACOES_ATA](state) {
		state.informacoesAta = { processo: {} }
	},
}
